module.exports = __webpack_public_path__ + "img/aoa_logo.9b5e319f.svg";